import React, { Component } from 'react';
import ClientInvoiceItem from '../../../Domain/ClientInvoiceItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ClientInvoiceWindowDescription from './ClientInvoiceWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import contactService from '../../../Services/contactService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ProjectAssignmentService from '../../../Services/ProjectAssignmentsService';
import OfficeService from '../../../Services/OfficeService';
import Loading from '../../../Elements/loading';

export default class ClientInvoiceEditPanel extends Component {
  static defaultProps = {
    type: '',
  };

  constructor(props) {
    super(props);
    this.itemEditedFunction = this.itemEditedFunction.bind(this);

    this.state = {
      availableContacts: [],
      CiDefaultReportName: '',
      billingCurrencyId: null,
      loading: true,
    };
  }

  async itemEditedFunction(editedItem) {
    if (this.CiBtid === editedItem.CiBtid) {
      return;
    }
    this.CiBtid = editedItem.CiBtid;
    const selectedContact = this.state.availableContacts.find(
      (f) => f.contactId.toString() === editedItem.CiBtid.toString()
    );

    if (selectedContact) {
      editedItem.CiVatnumber = selectedContact.vatnumber;
    }
  }

  componentDidMount() {
    // Load everything that seeds the initial edited item before mounting the wizard: unlike the old
    // GeneralEditPanel, GeneralEditWizzardBaseFigma captures editedItem once at mount and ignores later
    // prop changes, so these async values must be present before the first render of the wizard.
    Promise.allSettled([
      contactService.GetContactListByClientId(this.props.Service.ClientId),
      ProjectAssignmentService.GetProjectAssignmentAdditionalInformation(this.props.Service.ClientId),
      OfficeService.GetOfficeBillingCurrency(this.props.Service.OfficeId),
    ]).then(([contacts, additionalInformation, currency]) => {
      const nextState = { loading: false };

      if (contacts.status === 'fulfilled') {
        nextState.availableContacts = contacts.value;
      } else {
        ErrorMessage.SetErrorMessage('CIA47');
      }

      if (additionalInformation.status === 'fulfilled') {
        nextState.CiDefaultReportName = additionalInformation.value.ciDefaultReportName;
      } else {
        ErrorMessage.SetErrorMessage('CIA56');
      }

      if (currency.status === 'fulfilled') {
        if (currency.value) {
          nextState.billingCurrencyId = currency.value.currencyId;
        } else {
          ErrorMessage.SetErrorMessage('No billing currency found for the office');
        }
      } else {
        ErrorMessage.SetErrorMessage('CIA67');
      }

      this.setState(nextState);
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const clientInvoice = new ClientInvoiceItem();
    clientInvoice.ClientName = this.props.Service.ClientName;
    clientInvoice.ServiceFeeId = this.props.editedItem.ServiceFeeId;
    clientInvoice.CiCcid = this.props.Service.ClientId;
    clientInvoice.CiOfficeId = this.props.Service.OfficeId;
    clientInvoice.CiRcyid = this.props.Service.OpportunityCurrency;
    clientInvoice.OpportunityCurrencyName = this.props.Service.OpportunityCurrencyName;
    clientInvoice.Type = this.props.type;
    clientInvoice.CiDefaultReportName = this.state.CiDefaultReportName;

    if (this.state.billingCurrencyId !== null) {
      clientInvoice.CiRcyid = this.state.billingCurrencyId;
    }

    return (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Create}
        editedItem={clientInvoice}
        clickOnCancel={this.props.onClose}
        clickOnSave={this.props.onClose}
        windowDescription={ClientInvoiceWindowDescription}
        onChangeEditedItem={this.itemEditedFunction}
        errorCode='CLIA82'
      />
    );
  }
}
